import BioMaterial from "../../components/biologicals/BioMaterial.vue";
import BioMaterialForm from "../../components/biologicals/BioMaterialForm.vue";
import BioMaterialRemove from "../../components/biologicals/BioMaterialRemove.vue";
import BioMaterialView from "../../components/biologicals/BioMaterialView.vue";
import BioProjectMaterials from "../../components/biologicals/BioProjectMaterials.vue";
import BioSpaceListing from "../../components/biologicals/BioSpaceListing.vue";
import BioProjectListing from "../../components/biologicals/BioProjectListing.vue";
import { uuidPattern } from "../../lib/raft_generic_helper";

require("./css/Bio.css");

const machinePattern = "[a-z0-9_]+";

const routes = [
  {
    path:
      "/node/:groupNid([0-9]+)/biologicals/bio/:materialType(" +
      machinePattern +
      ")/:uuid(" +
      uuidPattern +
      ")",
    component: BioMaterialView,
    props: true,
  },
  {
    path:
      "/node/:groupNid([0-9]+)/biologicals/bio/:materialType(" +
      machinePattern +
      ")/:uuid(" +
      uuidPattern +
      ")/edit",
    component: BioMaterialForm,
    props: true,
  },
  {
    path:
      "/node/:groupNid([0-9]+)/biologicals/bio/:materialType(" +
      machinePattern +
      ")/:uuid(" +
      uuidPattern +
      ")/remove",
    component: BioMaterialRemove,
    props: true,
  },
  {
    path:
      "/raft/biologicals/:materialType(" +
      machinePattern +
      ")/:uuid(" +
      uuidPattern +
      ")",
    component: BioMaterialView,
    props: true,
  },
  {
    path:
      "/raft/biologicals/:materialType(" +
      machinePattern +
      ")/:uuid(" +
      uuidPattern +
      ")/edit",
    component: BioMaterialForm,
    props: true,
  },
  {
    path:
      "/raft/biologicals/:materialType(" +
      machinePattern +
      ")/:uuid(" +
      uuidPattern +
      ")/remove",
    component: BioMaterialRemove,
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/biologicals/projects/bio-tracking",
    component: BioProjectMaterials,
    props: (route) => ({
      groupNid: route.params.groupNid,
      defaultProjectNid: route.query.project,
      displaySearchAdd: true,
    }),
  },
  {
    path: "/node/:spaceNid([0-9]+)/bio-space-listing",
    component: BioSpaceListing,
    props: true,
  },
  {
    path: "/raft/biologicals/projects",
    component: BioProjectListing,
    props: true,
  },
];

const globalComponents = {
  BioMaterial,
  BioProjectMaterials,
};

export {
  routes as bioMaterialsRoutes,
  globalComponents as bioMaterialsGlobalComponents,
};
